import * as React from 'react';

import {useParams, useNavigate, useRevalidator} from 'react-router-dom';
import {useMessage} from "../context/MessageProvider";

import { useTheme } from '@mui/material/styles';

import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Unstable_Grid2'; // Grid version 2
import Button from '@mui/material/Button';
import EwpButton from "../components/EwpButton";
import StatusIcon from '../components/StatusIcon';
import Row from '../components/Row';
import StatusText from '../components/StatusText';

import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import IconButton from '@mui/material/IconButton';
import PlaylistAddIcon from '@mui/icons-material/PlaylistAdd';
import MoreVertIcon from '@mui/icons-material/MoreVert';

import CardActions from '@mui/material/CardActions';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';


import { getAssessment, saveAssessment, deleteAssessment } from '../models/assessments';
import { getAnimal } from '../models/animals';
import { listSectionBsByAssessment, completeSectionB } from '../models/sectionb';
import { listSectionAsByAssessment, completeSectionA } from '../models/sectiona';
import { listSectionCsByAssessment} from '../models/sectionc';
import { listSectionCIoAsByAssessment} from '../models/sectioncioa';
import { listChanges } from "../models/changes";

import { isInProgress } from "../utils/assessments";
import { observationStatus, overallSectionStatus, inProgressObservation, finalEvaluationStatus } from '../utils/sections';
import { dateLocaleFormat } from "../utils/datetime";

import Subheader from '../components/Subheader';
import {useLoaderData} from 'react-router-dom';

//import {datetime} from "../utils/datetime";

import { useConfirmationDialog } from '../context/ConfirmationDialogContext';
import { useConnectivity } from '../context/ConnectivityProvider';
import { useLayout } from "../components/layout/Layout";
import CustomTooltip from '../components/tooltip/CustomTooltip';

import { allOpenAnimalChanges, sortDescStart } from '../utils/changes';

import ChangeSummaryCard from '../components/cards/ChangeSummaryCard';

import Stack from '@mui/material/Stack';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import { useSectionB } from '../context/SectionBProvider';

import { createSignedUrl } from '../utils/utils';

import { getFinalEvaluation } from '../models/finalevaluation';

const SectionBObservation = ({record,addHandler,...props}) => {

    const status = observationStatus(record);

    return (
        <Stack sx={{width: "100%", display: "flex", flexDirection: "row", justifyContent: "flex-start", alignItems: "center" }}>
            <StatusText status={status}>{record.observation_range} ({status})</StatusText>
            {(status === "In Progress" || status === "Not Started") ? <CustomTooltip keyString="add_to_clipboard" className=""><IconButton onClick={addHandler}><PlaylistAddIcon /></IconButton></CustomTooltip> : <></>}
        </Stack>
    );


};

export async function loader({params}) {
    console.log("loader params",params);

    const assessment = await getAssessment(params.assessmentId);
    const animal = await getAnimal(assessment.animal_id);

    const sectionAs = await listSectionAsByAssessment(assessment.id);
    const sectionBs = await listSectionBsByAssessment(assessment.id);
    const sectionCs = await listSectionCsByAssessment(assessment.id);
    const sectionCIoAs = await listSectionCIoAsByAssessment(assessment.id);

    const finalevaluation = await getFinalEvaluation(params.assessmentId);

    const changes = await listChanges();


    const reportUrl = (assessment?.report_path) ? await createSignedUrl({bucketName: process.env.REACT_APP_ASSESSMENT_REPORTS_BUCKET,bucketKey: assessment?.report_path, expiresIn: 300}) : undefined;


    return {assessment,animal, sectionAs, sectionBs, sectionCs, sectionCIoAs, changes, reportUrl, finalevaluation};
}

export default function AssessmentDashboardPage({title = "Assessment",...props}) {
    const {setSuccess, setError} = useMessage();
    const theme = useTheme();
    const params = useParams();
    const revalidator = useRevalidator();
    console.log("assessment dashboard id: ", params.assessmentId);
    const navigate = useNavigate();
    const {confirm} = useConfirmationDialog();
    const {isOnline} = useConnectivity();
    const {openChangesModal} = useLayout();

    const {inProgressObservations, addObservation} = useSectionB();
    const [headerMenuAnchorEl, setHeaderMenuAnchorEl] = React.useState(null);
    const isHeaderMenuOpen = Boolean(headerMenuAnchorEl);


    // const {isLoading, data} = useQuery({
    //     queryKey: ['sectiona','form',params.assessmentId,params.sectionAId],
    //     queryFn: async() => {

    console.log("inProgressObservations: ", inProgressObservations);

    const {assessment, animal, sectionAs, sectionBs, sectionCs, changes, reportUrl, finalevaluation } = useLoaderData();

    console.log("reportURL: ", reportUrl);

    console.log('assessment', assessment);
    console.log('final evaluation',finalevaluation);
    console.log("sectionAs",sectionAs);

    const observationInProgressA = inProgressObservation(sectionAs || []);
    const observationInProgressB = inProgressObservation(sectionBs || []);
    //const observationInProgressC = inProgressObservation(sectionCs || []);


    const statusSectionA = overallSectionStatus(sectionAs || []);
    const statusSectionB = overallSectionStatus(sectionBs || []);
    //const statusSectionC = overallSectionStatus(sectionCs || []);
    //const statusSectionCIoA =  (assessment.no_incidents_of_aggression) ? "Completed" :  overallSectionStatus(sectionCIoAs.map((cur)=>{ cur.submitted_on = cur.incident_time; return cur; }));
    const statusFinalEvaluation = finalEvaluationStatus(finalevaluation);
    const openChanges = allOpenAnimalChanges(animal, changes || []);
    openChanges.sort(sortDescStart);

    console.log("in progress A: ",observationInProgressA);
    console.log("in progress B: ",observationInProgressB);


    // handle the final submission of an assessment
    const handleStartFinalEvaluation = async () => {
        navigate("/assessments/" + assessment.id + "/finalevaluation");
    }

    const isInProgressStatus = isInProgress(assessment);

    const isFinalEvaluationActive = (statusSectionA === "Completed" || statusSectionB === "Completed") ? true : false

    const handleNewSectionA = async() => {
        console.log("click section a");
        navigate("/assessments/" + assessment.id + "/sectiona");
    };

    const handleContinueSectionA = (observation) => {
        console.log("click section a");
        navigate("/assessments/" + assessment.id + "/sectiona/" + observation.id);
    };

    const handleCompleteSectionA = async() => {
        try {
            confirm({
                title: "Submit Section A",
                message: <p style={{margin:0}}>
                    You are about to submit Section A.
                    <br/>
                    Are you sure?
                    <p style={{color:"red"}}>
                        This action cannot be undone
                    </p>
                </p>,
                onSubmit: async () => {
                    const completeResult = await completeSectionA(assessment.id,isOnline);
                    console.log(completeResult);
                    setSuccess("Marked Section A Complete");
                    revalidator.revalidate();
                },
            });
        } catch (error) {
            console.error(error);
            setError(error);
        }
    };

    const handleNewSectionB = async() => {
        console.log("click section b");
        navigate("/assessments/" + assessment.id + "/sectionb");
    };

    /*
    const handleNewSectionC = async() => {
        console.log("click section c");
        navigate("/assessments/" + assessment.id + "/sectionc");
    };
    */


    const handleContinueSectionB = (observation) => {
        console.log("click section b");
        navigate("/assessments/" + assessment.id + "/sectionb/" + observation.id);
    };
    /*
    const handleContinueSectionC = (observation) => {
        console.log("click section c");
        console.log(observation);
        navigate("/assessments/" + assessment.id + "/sectionc/" + observation.id);
    };
    */

    const handleCompleteSectionB = async() => {
        try {
            confirm({
                title: "Submit Section B",
                message: <p style={{margin:0}}>
                    You are about to submit Section B.
                    <br/>
                    Are you sure?
                    <p style={{color:"red"}}>
                        This action cannot be undone
                    </p>
                </p>,
                onSubmit: async () => {
                    const completeResult = await completeSectionB(assessment.id,isOnline);
                    console.log(completeResult);
                    setSuccess("Marked Section B Complete");
                    revalidator.revalidate();
                },
            });
        } catch (error) {
            console.error(error);
            setError(error);
        }
    };

    const handleAddChange = () => {
        openChangesModal({animal});
    };

    const handleAddObservation = (observation) => {
        addObservation({
            id: observation.id,
            assessmentId: assessment.id,
            title: assessment?.assessment_title || animal.name
        });
        setSuccess("Added section B observation to clipboard");
        navigate("/assessments/");
    };
    const handleOpenHeaderMenu = (event) => {
        setHeaderMenuAnchorEl(event.currentTarget);
    };

    const handleCloseHeaderMenu = () => {
        setHeaderMenuAnchorEl(null);
    };

    const handleCopyAssessmentId = async () => {
        try {
            await navigator.clipboard.writeText(String(assessment.id));
            setSuccess("Assessment ID copied to clipboard");
        } catch (error) {
            console.error(error);
            setError("Unable to copy assessment ID");
        } finally {
            handleCloseHeaderMenu();
        }
    };

    const isVisibleInReports = assessment?.is_visibile_in_reports !== false;

    const handleToggleVisibleInReports = async () => {
        try {
            const updatedVisibility = !isVisibleInReports;
            const updatedAssessment = {
                ...assessment,
                is_visibile_in_reports: updatedVisibility,
            };
            await saveAssessment(updatedAssessment, assessment.facility_id, assessment.user_id, isOnline);
            setSuccess(updatedVisibility ? "Marked visible in reports" : "Marked hidden in reports");
            revalidator.revalidate();
        } catch (error) {
            console.error(error);
            setError(error?.message || "Unable to update report visibility");
        } finally {
            handleCloseHeaderMenu();
        }
    };

    const handleDeleteAssessment = async () => {
        handleCloseHeaderMenu();

        try {
            confirm({
                title: "Delete Assessment",
                confirmButtonLabel: "Delete",
                message: <p style={{margin: 0}}>
                    You are about to permanently delete this assessment and all related records.
                    <br/>
                    Are you sure?
                    <p style={{color: "red"}}>
                        This action cannot be undone
                    </p>
                </p>,
                onSubmit: async () => {
                    try {
                        await deleteAssessment(assessment.id, isOnline);
                        setSuccess("Assessment deleted");
                        navigate("/assessments");
                    } catch (error) {
                        console.error(error);
                        setError(error?.message || "Unable to delete assessment");
                    }
                },
            });
        } catch (error) {
            console.error(error);
            setError(error?.message || "Unable to delete assessment");
        }
    };


    // note you can play with the container maxwidth to spread out the window content appears in
    return (
        <Container component="main" maxWidth="md" sx={{pl: 0, pr: 0}}>
            {sectionAs && sectionBs && sectionCs && <>
            <Card>
                <CardContent>
                    <CardHeader
                        title={assessment?.assessment_title || animal.name}
                        subheader={animal.studbook_number}
                        action={
                            <>
                                <IconButton
                                    aria-label="assessment actions"
                                    onClick={handleOpenHeaderMenu}
                                    size="small"
                                >
                                    <MoreVertIcon />
                                </IconButton>
                                <Menu
                                    anchorEl={headerMenuAnchorEl}
                                    open={isHeaderMenuOpen}
                                    onClose={handleCloseHeaderMenu}
                                    anchorOrigin={{vertical: 'bottom', horizontal: 'right'}}
                                    transformOrigin={{vertical: 'top', horizontal: 'right'}}
                                >
                                    <MenuItem onClick={handleCopyAssessmentId}>Copy ID to clipboard</MenuItem>
                                    <MenuItem onClick={handleToggleVisibleInReports}>
                                        {isVisibleInReports ? "Mark as hidden in reports" : "Mark as visible in reports"}
                                    </MenuItem>
                                    <MenuItem onClick={handleDeleteAssessment}>Delete assessment</MenuItem>
                                </Menu>
                            </>
                        }
                    />

                    <Grid container columnSpacing={2} rowSpacing={2}>

                      <Grid xs={6}>
                          <Stack>
                            <Typography variant="body1" color="secondary">Steps To Completion</Typography>
                            <Row sx={{my: 1}}><StatusIcon status={statusSectionA} /><Typography sx={{mx: 1}}>Section A</Typography></Row>
                            <Row sx={{my: 1}}><StatusIcon status={statusSectionB} /><Typography sx={{mx: 1}}>Section B</Typography></Row>
                            <Row sx={{my: 1}}><StatusIcon status={statusFinalEvaluation} /><Typography sx={{mx: 1}}>Final Evaluation</Typography></Row>
                          </Stack>
                      </Grid>

                      <Grid xs={6}>
                        <Stack sx={{mb: 2}}>
                          <Typography variant="body1" color="secondary">Status</Typography>

                          <Row><StatusIcon status={isInProgressStatus ? "In Progress" : "Submitted"} />
                            <Typography sx={{ ml: 1 }} variant="body2">{isInProgressStatus ? "In Progress" : "Submitted"}</Typography>
                          </Row>
                        </Stack>
                        <Stack sx={{mb: 2}}>
                          <Typography variant="body1" color="secondary">Started</Typography>
                          <Typography variant="body2">{assessment?.started_on?.format(dateLocaleFormat())}</Typography>
                        </Stack>
                        <Stack sx={{mb: 2}}>
                          <Typography variant="body1" color="secondary">Submitted</Typography>
                          <Typography variant="body2">{assessment?.submitted_on?.format(dateLocaleFormat())}</Typography>
                        </Stack>
                      </Grid>

                    </Grid>

                    <Card sx={{ my: 2 }}>
                      <CardHeader
                        avatar={theme.icons.REPORT}
                        title={<Subheader label="AWA Report" />}
                      />
                      <CardContent>
                        {isOnline && reportUrl && <>
                          <a href={reportUrl} target="_blank" rel="noopener noreferrer"><Typography variant="body1">{assessment?.report_title}</Typography></a>
                          <Typography variant="body2">{assessment?.report_range}</Typography>
                        </>}
                        {isOnline && !reportUrl && (
                          <Typography variant="body1">No stored PDF report available.</Typography>
                        )}
                        {!isOnline && (
                          <Typography variant="body1">Stored PDF only available when online.</Typography>
                        )}
                      </CardContent>
                      <CardActions>
                        <EwpButton onClick={() => navigate(`/assessments/${assessment.id}/report`)} disabled={isInProgressStatus}>
                          View Report
                        </EwpButton>
                      </CardActions>
                    </Card>


                    <Card sx={{my: 2}}>
                      <CardHeader
                        avatar={theme.icons.CHANGE}
                        title={<Subheader label="Any New Changes?" />}
                      />
                      <CardContent>
                        <Accordion defaultExpanded={false}>
                            <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                            >
                                <Stack sx={{width: "100%", display: "flex", flexDirection: "row", justifyContent: "flex-start"}}>
                                    <Typography sx={{}}>Changes</Typography>
                                    <Typography sx={{
                                          display: "flex",
                                          flexDirection: "row",
                                          flexWrap: "wrap",
                                          justifyContent: "center",
                                          alignContent: "center",
                                          alignItems: "center",
                                          backgroundColor: theme.palette.badge.main,
                                          color: theme.palette.text.main,
                                          boxSizing: "border-box",
                                          minWidth: "20px",
                                          fontSize: "0.75rem",
                                          lineHeight: 1,
                                          padding: "0 6px",
                                          height: "20px",
                                          borderRadius: "10px",
                                          marginLeft: 1,
                                    }}>{openChanges.length}</Typography>
                                </Stack>
                            </AccordionSummary>
                            <AccordionDetails>

                        {openChanges.map((change)=>{
                            return (
                                <Grid key={change.id} container columnSpacing={2} rowSpacing={2}>
                                    <Grid xs={12} sm={12}>
                                    <ChangeSummaryCard change={change} onActionAreaClick={()=>{navigate("/changes/" + change.id);}} />
                                    </Grid>
                                </Grid>
                            );
                        })}
                            </AccordionDetails>
                        </Accordion>
                      </CardContent>
                      <CardActions>
                        <Button variant="contained" onClick={handleAddChange}>Add Change</Button>
                      </CardActions>
                    </Card>


                    <Card sx={{my: 2}}>
                      <CardHeader
                        avatar={
                          <StatusIcon status={statusSectionA} />
                        }
                        title={<Subheader label="Section A" sx={{my: 0}} />}
                        subheader={statusSectionA}
                      />
                      <CardContent>
                        <Grid container columnSpacing={2} rowSpacing={2} sx={{alignItems: "center" }}>
                          {sectionAs?.length > 0 && sectionAs.map((cur)=>{
                            const status = observationStatus(cur);
                              return (
                                  <Grid xs={12} sm={6}>
                                      <StatusText status={status}>{cur.observation_range} ({status})</StatusText>
                                  </Grid>
                              );
                          })}
                        </Grid>
                      </CardContent>
                      <CardActions>
                        {isInProgressStatus &&
                            <>
                                {(statusSectionA === "Not Started" || statusSectionA === "In Progress") && <Grid xs={12} sm={6}>
                                    {observationInProgressA && <EwpButton onClick={()=>handleContinueSectionA(observationInProgressA)}>Continue</EwpButton>}
                                    {!observationInProgressA && <EwpButton onClick={handleNewSectionA}>Start Observation</EwpButton>}
                                </Grid>}

                                <Grid xs={12} sm={6}>
                                    {statusSectionA === "All Submitted" &&
                                    <EwpButton complete onClick={handleCompleteSectionA}>Complete Section</EwpButton>
                                    }
                                    {statusSectionA !== "All Submitted" &&
                                    <></>
                                    }
                                </Grid>
                            </>
                        }
                      </CardActions>
                    </Card>

                    <Card sx={{my: 2}}>
                      <CardHeader
                        avatar={
                          <StatusIcon status={statusSectionB} />
                        }
                        title={<Subheader label="Section B" sx={{my: 0}} />}
                        subheader={statusSectionB}
                      />
                      <CardContent>
                        <Grid container columnSpacing={2} rowSpacing={2} sx={{marginTop: 2,  alignItems: "center" }}>
                          {sectionBs?.length > 0 && sectionBs.map((cur)=>{
                              return (
                                  <Grid xs={12} sm={6}>
                                      <SectionBObservation record={cur} addHandler={()=>{
                                          handleAddObservation(cur);
                                      }} />
                                  </Grid>
                              );
                          })}
                        </Grid>
                      </CardContent>
                      <CardActions>
                        {isInProgressStatus &&
                            <>
                                {(statusSectionB === "Not Started" || statusSectionB === "In Progress") && <Grid xs={12} sm={6}>
                                    {observationInProgressB && <EwpButton onClick={()=>handleContinueSectionB(observationInProgressB)}>Continue Observation</EwpButton>}
                                    {!observationInProgressB && <EwpButton onClick={handleNewSectionB}>Start Observation</EwpButton>}
                                </Grid>}

                                <Grid xs={12} sm={6}>
                                    {statusSectionB === "All Submitted" && <EwpButton complete onClick={handleCompleteSectionB}>Complete Section</EwpButton>}
                                    {statusSectionB !== "All Submitted" && <></>}
                                </Grid>
                            </>
                        }
                      </CardActions>
                    </Card>




                    <Card sx={{my: 2}}>
                      <CardHeader
                        avatar={
                          <StatusIcon status={statusFinalEvaluation} />
                        }
                        title={<Subheader label="Final Evaluation" sx={{my: 0}} />}
                        subheader={statusFinalEvaluation}
                      />
                      <CardContent>
                        <Grid container columnSpacing={2} rowSpacing={2} sx={{marginTop: 2,  alignItems: "center" }}>

                          <Grid xs={12} sx={{ textAlign: "left" }}>
                            <Typography variant="body1">{(isFinalEvaluationActive) ?"Final Evaluation can be started." : "You need to complete Section A or Section B, before starting the Final Evaluation."}</Typography>
                          </Grid>

                        </Grid>
                      </CardContent>
                      <CardActions>
                        {isInProgressStatus &&
                            <>
                                <Grid xs={12} sm={6}>
                                    <EwpButton onClick={handleStartFinalEvaluation} disabled={(isFinalEvaluationActive) ? false : true}>Start </EwpButton>
                                </Grid>
                            </>
                        }
                      </CardActions>
                    </Card>

                </CardContent>
            </Card>
            </>}
        </Container>
    );
}
